import { asSingleStyleConfig } from '../../../../utils/theme';
import { Input } from './input';
export var NumberInput = asSingleStyleConfig({
  variants: Input.variants,
  baseStyle: {
    incrementIcon: {
      '&:before': {
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg focusable='false' class='tqc-icon css-zxb96l' viewBox='2.83 6 20 14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%231F1F1F' d='M 7.83 13 L 2.83 20 L 12.83 20 L 22.83 20 L 17.83 13 L 12.83 6 L 7.83 13 Z'/%3E%3C/svg%3E\");"
      }
    },
    decrementIcon: {
      '&:before': {
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' focusable='false' class='tqc-icon css-zxb96l' viewBox='2.83 6 20 14'%3E%3Cpath fill='%231F1F1F' d='M7.83 13L2.83 6L12.83 6L22.83 6L17.83 13L12.83 20L7.83 13Z'/%3E%3C/svg%3E\");"
      }
    }
  },
  sizes: {
    md: {
      field: {
        borderRadius: 'none'
      }
    }
  }
});